import type { InsightResult } from '../models/insight.types'
import type { InsightFilters } from '../models/insightDisplay.types'

import { normalizeOutcomeCategory, normalizeSeverity } from './insightPresentation'

import { strIncludes } from '@/shared/lib/string'

const SEARCH_FIELDS = [
  'title',
  'label',
  'content',
  'config_enum',
  'platform',
  'platform_label',
  'impact_metric',
] as const satisfies readonly (keyof InsightResult)[]

/** Temporary BE-INS-04 bridge: the legacy endpoint returns the full collection without params. */
export function filterInsights(
  insights: readonly InsightResult[],
  filters: Readonly<InsightFilters>,
): InsightResult[] {
  const query = filters.q.trim()
  return insights.filter((insight) => {
    if (filters.outcome && normalizeOutcomeCategory(insight.outcome_category) !== filters.outcome) {
      return false
    }
    if (filters.severity && normalizeSeverity(insight.severity) !== filters.severity) return false
    if (filters.platform && insight.platform?.trim() !== filters.platform) return false
    return (
      query === '' ||
      SEARCH_FIELDS.some((field) => strIncludes(String(insight[field] ?? ''), query))
    )
  })
}

export function hasActiveInsightFilters(filters: Readonly<InsightFilters>): boolean {
  return Boolean(filters.outcome || filters.severity || filters.platform || filters.q.trim())
}
